import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Alert,
} from "reactstrap";
import axios from "axios";
import { showToast } from "../../../utils/toast";

const API_URL = process.env.REACT_APP_API_URL;

const AgreementStatusModal = ({ isOpen, toggle, organization, onSuccess, role = 'superadmin' }) => {
  const [decision, setDecision] = useState("");
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!organization) return null;

  const handleSubmit = async () => {
    if (role === 'subadmin') {
      setError('Access denied: only admin or superadmin can update agreement status');
      return;
    }

    if (!decision) {
      setError("Please select a decision");
      return;
    }

    if (!remarks.trim()) {
      setError("Remarks are required");
      return;
    }

    try {
      setLoading(true);
      setError("");

      // Decision endpoint lives under /superadmin and allows admin+superadmin via authRole
      const response = await axios.patch(
        `${API_URL}/superadmin/organizations/${organization.id}/decision`,
        {
          decision,
          remarks,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || localStorage.getItem("token")}`,
          },
        }
      );

      showToast("success", `${response?.data.message}`);
      toggle();
      onSuccess?.();
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to update agreement status"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Update Agreement Status</ModalHeader>

      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}

        {role === 'subadmin' ? (
          <Alert color="warning" className="mb-0">
            Access denied: only admin or superadmin can update agreement status.
          </Alert>
        ) : (
          <Form>
            <FormGroup>
              <Label>Decision *</Label>
              <Input
                type="select"
                value={decision}
                onChange={(e) => setDecision(e.target.value)}
              >
                <option value="">Select Decision</option>
                <option value="APPROVE">Approve</option>
                <option value="REJECT">Reject</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label>Remarks *</Label>
              <Input
                type="textarea"
                rows="3"
                placeholder="Enter remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </FormGroup>
          </Form>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Close
        </Button>
        {role !== 'subadmin' && (
          <Button color="success" onClick={handleSubmit} disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Submit"}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default AgreementStatusModal;

